import * as React from 'react';

import OneNetwork from '../assets/one-network-logo.png';

export default function OneNetworkLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={OneNetwork} alt='OneNetwork logo' {...props} />;
}
